import React from "react";
import "./FooterStyles.css";
import {
  facebook,
  instagram,
  logoFav,
  twitter,
  linkedin,
  email,
} from "../../assets";

const Footer = () => {
  return (
    <>
      <footer className="footer-sec">
        <div className="main">
          <div className="footerLogo row">
            <div className="footer-header">
              <img src={logoFav} className="manik" alt="" />
            </div>
            <div className="logo-des">
              <p>
                We offer a wide range of standout features to maintain the
                convenience to our customers.
              </p>
            </div>
          </div>

          <div className="link row">
            <div className="footer-header">
              <h3>ABOUT US</h3>
            </div>
            <div className="link-des">
              <a href="#" className="footer-links">
                About Us
              </a>
              <a href="#" className="footer-links">
                Careers
              </a>
              <a href="#" className="footer-links">
                Locate Stores
              </a>
              <a href="#" className="footer-links">
                Contact
              </a>
              <a href="#" className="footer-links">
                Own Grown
              </a>
              <a href="#" className="footer-links">
                Maintenance
              </a>
            </div>
          </div>

          <div className="link row">
            <div className="footer-header">
              <h3>CATEGORIES</h3>
            </div>

            <div className="link-des">
              <a href="#" className="footer-links">
                Gardening
              </a>
              <a href="#" className="footer-links">
                Plants
              </a>
              <a href="#" className="footer-links">
                Seeds
              </a>
              <a href="#" className="footer-links">
                Bulbs
              </a>
              <a href="#" className="footer-links">
                Pots
              </a>
              <a href="#" className="footer-links">
                Soil
              </a>
              <a href="#" className="footer-links">
                Pebbles
              </a>
              <a href="#" className="footer-links">
                Accesories
              </a>
            </div>
          </div>

          <div className="newsletter row">
            <div className="footer-header">
              <h3>NEWSLETTER</h3>
            </div>
            <div className="newsletter-des">
              <div className="subcribe">
                <img src={email} alt="" />
                <input type="mail" placeholder="Enter Email ID" required />
                <i className="sub-icon ri-arrow-right-line"></i>
              </div>
              <div className="icons">
                <div className="icon">
                  <a href="#">
                    <img src={facebook} alt="" />
                  </a>
                </div>
                <div className="icon">
                  <a href="#">
                    <img src={instagram} alt="" />
                  </a>
                </div>
                <div className="icon">
                  <a href="#">
                    <img src={linkedin} alt="" />
                  </a>
                </div>
                <div className="icon">
                  <a href="#">
                    <img src={twitter} alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <hr />

          <p>© Copyright 2024 UrbanGarden.</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
